import axios from "axios";
import { domain } from "./consts";
import iziToast from "izitoast";

const instance = axios.create();
instance.defaults.baseURL = domain.prod;
instance.defaults.headers.common["appId"] = "21";
instance.defaults.headers.common["platform"] = "web";
instance.interceptors.request.use(
  function (config) {
    config.headers.common["lcid"] = sessionStorage.getItem("lcid") || "1028";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  function (response) {
    if (response.status == 200) {
      return response.data;
    } else {
      iziToast.error({
        title: "error",
        message: response.errMsg,
        close: false,
        drag: false,
      });
      return Promise.reject(response);
    }
  },
  function (error) {
    iziToast.error({
      title: "error",
      message: error.message,
      close: false,
      drag: false,
    });
    return Promise.reject(error);
  }
);

const get = (url, params) => instance.get(url, { params });

const post = (url, body) => instance.post(url, body);

const postParams = (url, params, body) => instance.post(url, body, { params });

export { get, post, postParams };
